// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import HomePage from './pages/Homepage';
import AboutPage from './pages/AboutPage';
import GalleryPage from './pages/BlogPage';
import ContactPage from './pages/ContactPage';
import BlogPage from './pages/BlogPage';
import Blog from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import SluzbyCennik from "./pages/SluzbyCennik";
import Login from "./pages/Login";
import AdminPage from "./pages/AdminPage";
import { Toaster } from 'react-hot-toast';
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import {CookieBanner} from "./components/CookieBanner";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";

const App: React.FC = () => {
    return (
        <Router>
            <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
                <Header />
                <Toaster position="top-right" />
                <CookieBanner />
                <ScrollToTop /> {/* Add this component */}

                <main style={{ flex: 1 }}>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/o-mne" element={<AboutPage />} />
                        <Route path="/sluzby-cennik" element={<SluzbyCennik />} />
                        <Route path="/blog" element={<BlogPage />} />
                        <Route path="/blog/:id" element={<BlogPostPage />} />
                        <Route path="/gallery" element={<GalleryPage />} />
                        <Route path="/kontakt" element={<ContactPage />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/ochrana-osobnych-udajov" element={<PrivacyPolicyPage />} />

                        {/* Protected admin route */}
                        <Route
                            path="/admin/*"
                            element={
                                <ProtectedRoute>
                                    <AdminPage />
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                </main>

                <Footer />
            </div>
        </Router>
    );
};

export default App;